// extracted by mini-css-extract-plugin
export default {"input":"MessageInput_input__grDeZ"};